module.exports = __webpack_public_path__ + "thx.c634ab8b.png";